import React, { useState } from "react";
import Button from "../../../Elements/Button/Button";
import "./detalleEmpleadoHistorico.css";

export default function DetalleEmpleadoHistorico({ periodos = [], className = "" }) {
    const [expanded, setExpanded] = useState(false);

    return (
        <div className={`detalle-empleado-historico mb-4 ${className}`}>
            <h5 className="mb-2">
                <Button
                    text={`Histórico de Periodos ${expanded ? "▲" : "▼"}`}
                    action={() => setExpanded((e) => !e)}
                    color="red"
                    fill
                    aria-expanded={expanded}
                    type="button"
                />
            </h5>

            {expanded && (
                Array.isArray(periodos) && periodos.length > 0 ? (
                    <div className="table-responsive">
                        <table className="table table-sm">
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Ingreso</th>
                                    <th>Egreso</th>
                                    <th>Activo</th>
                                </tr>
                            </thead>
                            <tbody>
                                {periodos.map((p, i) => (
                                    <tr key={i}>
                                        <td>{i + 1}</td>
                                        <td>{p.fechaIngreso}</td>
                                        <td>{p.fechaEgreso || "—"}</td>
                                        <td>{p.activo ? "Sí" : "No"}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                ) : (
                    <div className="no-data">Sin periodos registrados.</div>
                )
            )}
        </div>
    );
}
